"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getCookieValue(cookieName) {
    try {
        const cookies = document.cookie.split('; ');
        if (cookies.length === 0) {
            return '';
        }
        const cookie = cookies.find((row) => row.startsWith(`${cookieName}=`));
        return cookie?.split('=')[1] || '';
    }
    catch (e) {
        console.error('Error finding cookie ' + cookieName, e);
        return '';
    }
}
exports.default = getCookieValue;
